import { useMutation } from '@apollo/client';
import { PUBLISH_CREATIVE } from '../../graphql/mutations/creativeMutations';
import { trackCreativeProfilePublished } from '../../util/tracking';

/**
 * Hook to publish a Creative profile
 * Uses the backend publishCreative mutation which handles validation
 * @returns {object} - { handlePublishCreative, loading, error }
 */
export const usePublishCreative = () => {
  const [publishCreativeMutation, { loading, error }] = useMutation(PUBLISH_CREATIVE, {
    refetchQueries: ['GetCreative', 'CreativesByUserID', 'StudioCreativesByStudioID'],
    awaitRefetchQueries: true
  });

  const handlePublishCreative = async (creativeId) => {
    try {
      if (!creativeId) {
        throw new Error('Das Creative-Profil konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const { data } = await publishCreativeMutation({
        variables: { id: creativeId }
      });

      const response = data?.publishCreative;

      if (!response) {
        throw new Error('Creative-Profil konnte nicht veröffentlicht werden.');
      }

      trackCreativeProfilePublished({
        creativeId,
        creativeType: response?.creativeType,
        source: 'creative_profile'
      });

      return response;
    } catch (error) {
      console.error('Error publishing creative:', error);
      throw error;
    }
  };

  return {
    handlePublishCreative,
    loading,
    error
  };
};
